import React from 'react';

const ResidentServicesSection = () => {
  const handleMouseEnter = (e) => {
    const card = e.currentTarget;
    const title = card.querySelector('h3');
    const description = card.querySelector('p');
    const icon = card.querySelector('img');
    
    card.style.backgroundColor = '#db0058';
    if (title) title.style.color = 'white';
    if (description) description.style.color = 'white';
    if (icon) icon.style.filter = 'brightness(0) invert(1)';
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    const title = card.querySelector('h3');
    const description = card.querySelector('p');
    const icon = card.querySelector('img');
    
    card.style.backgroundColor = 'white';
    if (title) title.style.color = '#111827'; // text-gray-900
    if (description) description.style.color = '#374151'; // text-gray-700
    if (icon) icon.style.filter = 'none';
  };

  return (
    <section className="bg-gray-200 py-12 sm:py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-left mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-5xl font-bold text-gray-900 leading-tight">
            Make a difference<br />
            <span style={{ color: '#db0058' }}>with data.</span>
          </h2>
        </div>
        
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Predictive Models & Profiling */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon1.webp"
                alt="Predictive Models & Profiling Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Predictive Models & Profiling
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              increase response and sales conversion, drive accurate targeting, market sizing and personalisation opportunities.
            </p>
          </div>

          {/* Channel Marketing */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon2.webp"
                alt="Channel Marketing Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Channel Marketing
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              for Email, Direct Mail, Mobile, Landline, Social and Programmatic contact and engagement.
            </p>
          </div>

          {/* Optimisation & Growth */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon5.webp"
                alt="Optimisation & Growth Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Optimisation & Growth
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              more targeted communications, accurate forecasting and channel optimised driving an increase in sales and ROI.
            </p>
          </div>

          {/* Insight & Analytics */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon6.webp"
                alt="Insight & Analytics Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Insight & Analytics
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              to uncover facts and patterns in data to drive business change.
            </p>
          </div>

          {/* Data Hygiene & Cleansing */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon3.webp"
                alt="Data Hygiene & Cleansing Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Data Hygiene & Cleansing
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              improve data quality and accuracy, driving efficiencies in contact whilst reducing wastage.
            </p>
          </div>

          {/* Indicative Quoting */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg cursor-pointer"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}>
            <div className="mb-6">
              <img
                src="/icons/picon4.webp"
                alt="Indicative Quoting Icon"
                className="w-16 h-14 transition-all duration-300"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 transition-colors duration-300">
              Indicative Quoting
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed transition-colors duration-300">
              for insurance within a 5% tolerance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResidentServicesSection;